import React from 'react';
import PropTypes from 'prop-types';

export const IconBlackjack = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    height="34"
    viewBox="0 0 40 46"
    fill="none"
  >
    <rect x="11.8379" y="3.55981" width="28" height="39" rx="5" transform="rotate(6.4055 11.8379 3.55981)" fill="url(#blackjack_1)" />
    <mask id="mask0_776_9087" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="1" width="32" height="42">
      <rect y="3.22351" width="28.6257" height="40.288" rx="5.30106" transform="rotate(-4.90371 0 3.22351)" fill="#FFE5A4" />
    </mask>
    <g mask="url(#mask0_776_9087)">
      <rect y="3.22351" width="28.6257" height="40.288" transform="rotate(-4.90371 0 3.22351)" fill="#FFF0C8" />
      <path d="M31.9888 39.9419L28.7429 2.10869C28.6686 1.24291 27.8935 0.602349 27.0117 0.678004L1.46438 2.86985C0.582574 2.9455 -0.0721044 3.70874 0.00217517 4.57451L3.24809 42.4077C3.32237 43.2735 4.09749 43.9141 4.9793 43.8384L30.5266 41.6466C31.4084 41.5709 32.0631 40.8077 31.9888 39.9419ZM6.93596 10.4018C6.86168 9.53599 7.51636 8.77275 8.39817 8.6971C9.27998 8.62144 10.0551 9.26201 10.1294 10.1278C10.2037 10.9936 9.54898 11.7568 8.66717 11.8324C7.78536 11.9081 7.01024 11.2675 6.93596 10.4018ZM16.668 30.0966C16.1655 30.1397 15.6723 29.948 15.3368 29.5791L10.0087 23.7194C9.5351 23.1986 9.46934 22.4321 9.84731 21.8382L14.0994 15.1565C14.3671 14.7359 14.8205 14.463 15.323 14.4198C15.8255 14.3767 16.3187 14.5684 16.6542 14.9373L21.9823 20.797C22.4559 21.3179 22.5216 22.0844 22.1437 22.6783L17.8916 29.3599C17.6239 29.7805 17.1705 30.0535 16.668 30.0966ZM23.5928 35.8193C22.711 35.895 21.9359 35.2544 21.8616 34.3886C21.7873 33.5229 22.442 32.7596 23.3238 32.684C24.2056 32.6083 24.9807 33.2489 25.055 34.1147C25.1293 34.9804 24.4746 35.7437 23.5928 35.8193Z" fill="url(#blackjack_2)" />
    </g>
  </svg>
);

IconBlackjack.propTypes = {
  className: PropTypes.string,
};

IconBlackjack.defaultProps = {
  className: '',
};
